module.exports = __webpack_public_path__ + "static/media/business-tree-l.c0e2bf35.png";